import React, { useState } from 'react'
import { Provider } from 'react-redux'
import { store, persistor } from './store/store'
import './App.css';
import { ToastProvider } from 'react-toast-notifications'
import { PersistGate } from 'redux-persist/integration/react'
import Routes from './routes'
import { ConfigProvider } from 'antd'
//import 'antd/dist/antd.css';
import { NotificationContainer } from 'react-notifications';
import 'react-notifications/lib/notifications.css';
//import { ptBR } from 'antd/lib/locale/pt_BR';
import ptBR from 'antd/locale/pt_BR'
import { RecoilRoot } from 'recoil'
import 'rsuite/dist/rsuite.min.css';


function App() {

  return (<ToastProvider placement='top-right' style={{ zIndex: 9999999999999 }} zIndex={9999999999999}>
    <React.Fragment>
      <RecoilRoot>
        <ConfigProvider locale={ptBR}
          theme={{
            token: {
              "colorPrimary": "#06c",
              "fontSize": 12,
            }
          }}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>                
                  <Routes />   
            </PersistGate>
          </Provider>
        </ConfigProvider>
        <NotificationContainer />
      </RecoilRoot>
    </React.Fragment>

  </ToastProvider>
  );
}

export default App;
